module.exports = __webpack_public_path__ + "static/media/calendrier_2019_EN.4bd2628d.png";